export const setSaveFile = (state, payload) => {
   if (payload === null) {
      state.saveFile = [];
   } else {
      state.saveFile.push(payload);
   }
};

export const removeSaveFile = (state, payload) => {
   state.saveFile = state.saveFile.filter((file) => {
      return file.uploadedFile.hash_id !== payload.hash_id;
   });
};

export const setDatosCaucion = (state, payload) => {
   state.datosCaucion = payload;
};
